import { useField } from 'formik';
import React from 'react';
import FormTextArea, { FormTextAreaProps } from './FormTextArea';

export type FormikFormTextAreaProps = Omit<
  FormTextAreaProps,
  'value' | 'error' | 'touched' | 'onChange' | 'onBlur'
>;

const FormikFormTextArea: React.FunctionComponent<FormTextAreaProps> = props => {
  const [field, fieldMeta] = useField<string>(props.name);

  return (
    <FormTextArea
      {...props}
      name={field.name}
      value={field.value}
      error={fieldMeta.error}
      touched={fieldMeta.touched}
      onChange={field.onChange}
      onBlur={field.onBlur}
    />
  );
};

export default FormikFormTextArea;
